<template>
  <div>
    <div class="mt30">
      <div>
        <div class="main-text-style">
          <span style="color: #f6350f">*</span>工作室名称
        </div>
        <div class="pl16">
          <a-input
            class="input-style-2"
            type="text"
            placeholder="请输入工作室名称名称"
            v-model="info.name"
            :maxLength="100"
            :disabled="$parent.editInfo && $parent.editInfo.type == 'preview'"
          />
        </div>
      </div>
    </div>
    <div class="mt30">
      <div>
        <div class="main-text-style">
          <span style="color: #f6350f">*</span>级别选择
        </div>
        <div class="pl16">
          <a-radio-group name="radioGroup" v-model="info.levelType">
            <a-radio
              :value="item.value"
              v-for="(item, key) in levelOpt"
              :key="key"
            >
              {{ item.label }}
            </a-radio>
          </a-radio-group>
        </div>
      </div>
    </div>
    <!-- <div class="mt30">
      <div>
        <div class="main-text-style">
          <span style="color: #f6350f">*</span>团队类型
        </div>
        <div class="pl16">
          <a-radio-group v-model="info.teamType">
            <a-radio value="teacher">教师团队</a-radio>
            <a-radio value="student">学生团队</a-radio>
          </a-radio-group>
        </div>
      </div>
    </div> -->
    <div class="mt30">
      <div>
        <div class="main-text-style">
          <span style="color: #f6350f">*</span>主持人
        </div>
        <div class="pl16">
          <a-input
            class="input-style-2"
            type="text"
            :maxLength="30"
            placeholder="请输入主持人"
            v-model="info.principals"
            :disabled="$parent.editInfo && $parent.editInfo.type == 'preview'"
          />
        </div>
      </div>
    </div>
    <div class="mt30">
      <div>
        <div class="main-text-style">
          <span style="color: #f6350f">*</span>联系电话
        </div>
        <div class="pl16">
          <a-input
            class="input-style-2"
            type="text"
            placeholder="请输入联系电话"
            v-model="info.phone"
            :maxLength="11"
            onkeyup="value=value.replace(/[^\d]/g,'')"
            :disabled="$parent.editInfo && $parent.editInfo.type == 'preview'"
          />
        </div>
      </div>
    </div>
    <div class="mt30">
      <!-- teams -->
      <div>
        <div class="main-text-style">
          <span style="color: #f6350f">*</span>团队成员
        </div>

        <div class="pl16">
          <template v-for="(tag, index) in tags">
            <!-- <a-tooltip v-if="tag.length > 20" :key="tag" :title="tag">
              <a-tag
                class="add-member text-right"
                :key="tag"
                :closable="index !== 0"
                @close="() => handleClose(tag)"
              >
                {{ `${tag.slice(0, 20)}...` }}111
              </a-tag>
            </a-tooltip> -->
              <!-- v-else -->
            <a-tag
              class="add-member text-right"
              :key="index"
              :closable="true"
              @close="() => handleClose(tag)"
            >
              {{ tag }}
            </a-tag>
          </template>
          <a-input
            v-if="inputVisible"
            ref="input"
            type="text"
            size="small"
            :style="{ width: '150px' }"
            :value="inputValue"
            @change="handleInputChange"
            @blur="handleInputConfirm"
            @keyup.enter="handleInputConfirm"
            :maxLength="30"
            class="add-member text-left"
          />
          <a-tag
            v-else-if="tags.length < 20"
            style="background: #fff; borderstyle: dashed;display: inline-block;width: 150px;"
            @click="showInput"
            class="add-member text-center"
          >
            <a-icon type="plus" />添加成员
          </a-tag>
        </div>
      </div>
    </div>
    <div class="submit-btn" @click="goStep">下 一 步</div>
  </div>
</template>

<script>
import { checkName } from '@/api/index';
export default {
  name: '',
  components: {},
  props: {
    editInfoStep1: {
      type: Object,
    },
  },
  data() {
    return {
      info: {
        name: '',
        levelType: '1',
        teamType: 'teacher',
        phone: '',
        principals: '',
        teams: '',
      },

      tags: [],
      inputVisible: false,
      inputValue: '',

      levelOpt: [
        {
          value: '1',
          label: '省级',
        },
        {
          value: '2',
          label: '市级',
        },
        {
          value: '3',
          label: '县/区级',
        },
        {
          value: '4',
          label: '校级',
        },
      ],
      // flag: true,
    };
  },
  computed: {},
  watch: {},
  created() {},
  destroyed() {
    sessionStorage.setItem(
      `step${this.$store.state.user.id}`,
      JSON.stringify(this.info)
    );
  },
  mounted() {
    let oldInfo = JSON.parse(
      sessionStorage.getItem(`step${this.$store.state.user.id}`)
    );
    if (oldInfo) {
      this.info.name = oldInfo.name;
      this.info.levelType = oldInfo.levelType;
      this.info.principals = oldInfo.principals;
      this.info.phone = oldInfo.phone;
      this.info.teams = oldInfo.teams;
      if(oldInfo.teams == "") return
      this.tags = oldInfo.teams.split(',');
    }
    // this.info = this.editInfoStep1;
    // consol.elog(this.$route)
  },
  methods: {
    init(params) {
      this.tags = params.teams.split(',');
      // this.flag = flag;
    },
    handleClose(removedTag) {
      // console.log(removedTag)
      const tags = this.tags.filter((tag) => tag !== removedTag);
      this.tags = tags;
      // console.log(tags, '删除');
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick(function () {
        this.$refs.input.focus();
      });
    },
    handleInputChange(e) {
      this.inputValue = e.target.value;
    },
    handleInputConfirm() {
      const inputValue = this.inputValue;
      if (inputValue.length > 30) {
        // this.$message.warn('团队成员名称最大不能超过个30字符！');
        return false;
      }
      let tags = this.tags;
      if (tags.length >= 20) {
        this.$message.warn('团队成员不能超过个20成员！');
        return false;
      }
      if (inputValue && tags.indexOf(inputValue) === -1) {
        tags = [...tags, inputValue];
      }
      console.log(tags, '删除');
      Object.assign(this, {
        tags,
        inputVisible: false,
        inputValue: '',
      });
    },
    goStep() {
      // console.log(this.tags.join(','),'最后tags')
      if (this.info.name.trim() === '' || this.info.name == undefined || this.info.name == null) {
        this.$message.info('请填写工作室名称');
        return false;
      } else if (this.info && this.info.levelType === '') {
        if (this.info.levelType == '' || this.info.levelType == undefined) {
          this.$message.info('请选择级别');
          return false;
        }
      } else if (this.info.principals.trim() === '' || this.info.principals == undefined || this.info.principals == null) {
        this.$message.info('请填写主持人');
        return false;
      } else if (this.info && this.tags.length == 0) {
        this.$message.info('请添加团队成员');
        return false;
      }
      if (
        (this.info && this.info.phone && this.info.phone === '') ||
        this.info.phone == undefined
      ) {
        this.$message.error('请输入手机号');
        return false;
      } else {
        var telStr = /^[1]([3-9])[0-9]{9}$/;
        if (!telStr.test(this.info.phone)) {
          this.$message.error('请输入正确格式手机号');
          return false;
        }
      }
      // 校验重复
      checkName({
        applyType: 2,
        name: this.info.name,
        id:this.$route.params.id,
      }).then((res) => {
        if (res.message == '信息可用') {
          this.info.teams = this.tags.join(',');
          this.$emit('goStep', this.info);
        } else {
          this.$message.info(res.message);
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.mt30 {
  margin-top: 20px;
}
.main-text-style {
  font-size: 19px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  margin-bottom: 15px;
}
.input-style-2 {
  width: 100%;
  padding: 10px 20px;
  height: 54px;
  border: 1px solid #d9d9d9;
  font-size: 16px !important;
  color: #999999;
}
.submit-btn {
  width: 116px;
  height: 40px;
  margin: 0 auto;
  margin-top: 50px;
  line-height: 38px;
  text-align: center;
  background: #9A0B00;
  border-radius: 10px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
}
.tag {
  font-size: 16px;
  cursor: pointer;
}
</style>

<style scoped>
.mt30 .ant-tag {
  margin: 4px 8px 4px 0;
}
</style>

<style lang="scss" scoped>
.add-member{
  height: 54px;
  font-size: 16px;
  line-height: 54px;
}
.text-left{
  text-align: left;
}
.text-center{
  text-align: center;
}
.text-right{
  text-align: right;
}
</style>